import React from 'react';
import PropTypes from 'prop-types';
import styles from './Columns.module.scss';

const ContentColumn = ({ children, className, ...rest }) => (
  <div className={`col-xl-9 col-lg-8 col-md-12 ${styles.content} ${className}`} {...rest}>
    {children}
  </div>
);

ContentColumn.propTypes = {
  className: PropTypes.string
};

ContentColumn.defaultProps = {
  className: ''
};

export default ContentColumn;
